/// <reference path="../../../app.definition.ts" />

import angular from "angular";
import {Util} from "@common/util";

//TO-DO - need to modify this popup will get only owner id and subject id
// based on that make call to API and fetch the data in this controller only

export class TransferTeamOwnerController {

    static $inject = ["$scope",
        "$state",
        "$http",
        "$filter",
        "CacheService",
        "$sce",
        "$uibModalInstance",
        "ApiAdapterService",
        "PopUpService",
        "teamMember",
        "subject",
        "transferAgain",
        "requestObj",
        "isExit",
        "cancelAndTransferAgain",
        "title",
        "displayMessage",
    ];

    constructor($scope,
        $state,
        $http,
        $filter,
        CacheService,
        $sce,
        $uibModalInstance,
        ApiAdapterService,
        PopUpService,
        teamMember,
        subject,
        transferAgain,
        requestObj,
        isExit,
        cancelAndTransferAgain,
        title,
        displayMessage
    ) {
        var transferTeamOwnerVm: any = this;
        transferTeamOwnerVm.teamMemberList = [];
        transferTeamOwnerVm.Owner = {};
        transferTeamOwnerVm.subject = {};
        transferTeamOwnerVm.selected = {};
        transferTeamOwnerVm.transferAgain = false;
        transferTeamOwnerVm.requestObj = {};
        transferTeamOwnerVm.isExit = false;
        transferTeamOwnerVm.cancelAndTransferAgain = false;
        transferTeamOwnerVm.displayMessage = null;
        transferTeamOwnerVm.title = null;
        transferTeamOwnerVm.noRecordsFound = Util.NO_MATCH_UISELECT;


        transferTeamOwnerVm.init = () => {
            transferTeamOwnerVm.currentOwener = Array.isArray(teamMember) ? teamMember[0] : teamMember;
            transferTeamOwnerVm.Owner = Array.isArray(teamMember) ? teamMember[0] : teamMember;
            transferTeamOwnerVm.subject = subject;
            transferTeamOwnerVm.selected = transferTeamOwnerVm.Owner;
            transferTeamOwnerVm.transferAgain = transferAgain;
            transferTeamOwnerVm.requestObj = requestObj;
            transferTeamOwnerVm.isExit = isExit;
            transferTeamOwnerVm.cancelAndTransferAgain = cancelAndTransferAgain;
            transferTeamOwnerVm.displayMessage = displayMessage;
            transferTeamOwnerVm.displayMessageAsAdmin = Util.TRANSFER_OWNERSHIP_AS_ADMIN_TEXT;
            transferTeamOwnerVm.title = title;
            transferTeamOwnerVm.exit = (typeof (transferTeamOwnerVm.isExit) === 'string' || transferTeamOwnerVm.isExit == true);
            transferTeamOwnerVm.tooltipForTransfer = $sce.trustAsHtml("<html><body>By transferring the Team Captain badge you are transferring ownership and full management of the Team.</body></html>");
            transferTeamOwnerVm.tooltipForTransferForAdmin = Util.TRANSFER_OWNERSHIP_AS_ADMIN_TOOLTIP
            transferTeamOwnerVm.getActiveTM()
        }

        // transferTeamOwnerVm.teamMemberList.push(angular.copy(tm));


        transferTeamOwnerVm.getActiveTM = () => {
            console.log("thissubject1", subject);
            if (subject.teamMemberList) {
                subject.teamMemberList.map(tm => {
                    tm.id != teamMember.id && tm.isActive && !tm.isFormerTeamMember && !tm.captain && transferTeamOwnerVm.teamMemberList.push(angular.copy(tm))
                })
            }
            else {
                subject.teamMembers.map(tm => {
                    tm.id != teamMember.id && tm.isActive && !tm.isFormerTeamMember && !tm.captain && transferTeamOwnerVm.teamMemberList.push(angular.copy(tm))
                })
            }
        }

        transferTeamOwnerVm.closePopup = () => {
            $uibModalInstance.dismiss();
        }

        transferTeamOwnerVm.dontTransfer = () => {
            if (transferTeamOwnerVm.transferAgain) {
                transferTeamOwnerVm.updateRequestStatus();
            }
            $uibModalInstance.close(false);
        }

        transferTeamOwnerVm.updateRequestStatus = () => {
            console.log(transferTeamOwnerVm.requestObj.id);
            ApiAdapterService.updateOwnershipRecord(transferTeamOwnerVm.requestObj, true).then(
                (s) => {
                    $uibModalInstance.dismiss();
                }, (e) => {
                }
            );
        }

        transferTeamOwnerVm.transferTeamOwner = (form) => {
            transferTeamOwnerVm.transferLoader = "Transferring Team Captain Badge... ";
            if (transferTeamOwnerVm.transferAgain) {
                transferTeamOwnerVm.updateRequestStatus();
            }

            ApiAdapterService.transferTeamOwnership(transferTeamOwnerVm.subject.subjectId,
                transferTeamOwnerVm.selected, transferTeamOwnerVm.exit).then(
                    (s) => {
                        transferTeamOwnerVm.transferLoader = false;
                        $uibModalInstance.close(true);
                        toastr.success("Team Captain badge transfer request has been sent successfully.");
                    }, (e) => {
                        transferTeamOwnerVm.transferLoader = false;
                        PopUpService.openInformationModal(e);
                        //$uibModalInstance.close(false);
                    }
                );
        }
        transferTeamOwnerVm.init();
    }
}


angular.module('eCareVault.common.popUp')
    .controller('TransferTeamOwnerController', TransferTeamOwnerController);
